import { Container } from "@/components/ui/Container";
import { SpacingProps } from "@/theme/spacing";
import { CSSProperties } from "react";
import clsx from "clsx";
import { Row } from "@/components";
import "./HeaderSlim.scss";
import { WithVariant } from "@/types/variant";

type HeaderSlimProps = {
  as?: "div" | "header";
  className?: string;
  containerClassName?: string;
  hasContainer?: boolean;
  display?: CSSProperties["display"];
  justifyContent?: CSSProperties["justifyContent"];
  alignItems?: CSSProperties["alignItems"];
  flexWrap?: CSSProperties["flexWrap"];
  children: React.ReactNode;
} & SpacingProps;

export const HeaderSlim = ({
  as = "div",
  className,
  containerClassName = "bg-slate-20",
  hasContainer = true,
  display,
  justifyContent,
  alignItems,
  flexWrap,
  children,
  variant = "default"
}: WithVariant<HeaderSlimProps>) => {
  const Component = as;
  const containerComponent = () => {
    if (hasContainer) {
      return (
        <Container
          containerClass={"ui-container"}
          className={clsx(
            "min-h-x48 base-row align-items-center py-x12",
            className,
            variant === 'operator' && "ui-hslim-menu--operator"
          )}
          display={display}
          justifyContent={justifyContent}
          alignItems={alignItems}
          flexWrap={flexWrap}
        >
          {children}
        </Container>
      );
    }
    return (
      <Row
        alignItems={"center"}
        py={"x12"}
        className={clsx("min-h-x48 ", className)}
        style={{
          display,
          justifyContent,
          alignItems,
          flexWrap,
        }}
      >
        {children}
      </Row>
    );
  };

  return <Component className={containerClassName}>{containerComponent()}</Component>;
};
